import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mdTemplate]',
})
export class DropdownTemplateDirective {
  // @ts-expect-error
  @Input('mdTemplate') type: 'option' | 'selected';

  constructor(public template: TemplateRef<any>) {}
}
